export default function initFaqAccordion() {
  document.querySelectorAll('.autonia-faq-trigger').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item   = trigger.closest('.autonia-faq-item');
      const isOpen = item.classList.contains('is-open');

      document.querySelectorAll('.autonia-faq-item').forEach((el) => {
        el.classList.remove('is-open');
        el.querySelector('.autonia-faq-answer').classList.remove('is-open');
        el.querySelector('.autonia-faq-trigger').setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        item.classList.add('is-open');
        item.querySelector('.autonia-faq-answer').classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
}
